import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import PrintLabel from '../../components/PrintLabel';

class Label extends Component {
  constructor(props) {
    super(props);
    this.windowPrint = this.windowPrint.bind(this);
    this.state = {
      show: true,
      tabOnTop: true,
    };
  }
  windowPrint = () => {
    this.setState({
      show: false
    });
    window.print();
  }
  gotoOrders = () => {
    browserHistory.push('/orders');
  }
  render() {
    const { order, from, to } = this.props;
    const locations = { list: [from, to] };
    const { show } = this.state;

    let piece = 0;
    const total = order.trackingNumbers.length;

    const content = order.trackingNumbers.map((item) => {
      piece += 1;
      return (
        <PrintLabel
          key={item.trackingNumber}
          onClick={() => { window.print() }}
          trackingNumber={item.trackingNumber}
          from={order.from}
          to={order.to}
          serviceLevel={order.serviceLevel}
          code={order.code}
          locations={locations.list}
          reference={order.reference}
          piece={piece}
          total={total}
          tabOnTop={this.state.tabOnTop}
          trackingNumbers={order.trackingNumbers}
          receipt={piece === total}
        />
      );
    });

    return (
      <div>
        
        <div className="hideOnPrint" style={{ marginBottom: 10 }}>
          <RaisedButton label="Orders" onClick={this.gotoOrders} />
          {show &&
            <RaisedButton label="Print" onClick={this.windowPrint}/>
          }
        </div>
        <div className="hideOnPrint" style={{ marginBottom: 40 }}>
          <Checkbox
            defaultChecked={this.state.tabOnTop}
            label="Tab on Top (uncheck if label tab on bottom of label rather than top)"
            onCheck={(e, value) => this.setState({ tabOnTop: value })}
          />
        </div>
        {content}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { from, to, order } = state.print;
  return {
    order,
    from,
    to
  }
}

export default connect(mapStateToProps)(Label);


// WEBPACK FOOTER //
// ./src/containers/Orders/Label.js